module.exports = __webpack_public_path__ + "static/media/poliquel_fe.3a7310ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/poliquel_fe.png
// module id = 1307
// module chunks = 3